const storage = {
  set(key, value) {
    if (typeof value === 'object') value = JSON.stringify(value)
    localStorage.setItem(key, value)
  },
  get(key) {
    try {
      var obj = JSON.parse(localStorage.getItem(key))
      if (typeof obj === 'object' && obj) {
        return JSON.parse(localStorage.getItem(key))
      } else {
        return localStorage.getItem(key)
      }
    } catch (e) {
      return localStorage.getItem(key)
    }
  },
  remove(key) {
    localStorage.removeItem(key)
  },
  clear() {
    localStorage.clear()
  }
}

const session = {
  set(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  get(key) {
    if (sessionStorage.getItem(key)) {
      return JSON.parse(sessionStorage.getItem(key))
    } else {
      return ''
    }
  },
  remove(key) {
    sessionStorage.removeItem(key)
  },
  clear() {
    sessionStorage.clear()
  }
}

/**
 * 时间戳转化为年 月 日 时 分 秒
 * date: 传入时间对象
 * format：返回格式，支持自定义
 */
function timeFormat(date, format) {
  // 日期解析
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return format
}

/**
 * 将图片转为base64
 * @param {*} img
 */
function getBase64Image(url, callback) {
  var Img = new Image()
  var dataURL = ''
  // Img.setAttribute("crossOrigin", 'Anonymous')
  Img.src = url + '?v=' + Math.random()
  Img.crossOrigin = '*'
  Img.onload = function() {
    // 要先确保图片完整获取到，这是个异步事件
    var canvas = document.createElement('canvas') // 创建canvas元素
    var width = Img.width // 确保canvas的尺寸和图片一样
    var height = Img.height
    canvas.width = width
    canvas.height = height
    canvas.getContext('2d').drawImage(Img, 0, 0, width, height) // 将图片绘制到canvas中
    dataURL = canvas.toDataURL('image/jpeg') // 转换图片为dataURL
    // console.log(dataURL)
    callback && callback(dataURL) // 调用回调函数
    return dataURL
  }
}

// base 转 file类型
function dataURLtoFile(dataurl, filename) {
  // 将base64转换为文件
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

function jsonStr(objstr) {
  return JSON.parse(JSON.stringify(objstr))
}

// 解析页面URL
function getUrlParam(url) {
  var paramStr = url.substring(url.indexOf('?') + 1, url.length).split('&')
  var j
  var paramObj = {}
  for (var i = 0; (j = paramStr[i]); i++) {
    paramObj[j.substring(0, j.indexOf('=')).toLowerCase()] = j.substring(j.indexOf('=') + 1, j.length)
  }

  var returnValue = paramObj

  if (typeof returnValue === 'undefined') {
    return ''
  } else {
    return returnValue
  }
}

export { storage, session, getBase64Image, dataURLtoFile, jsonStr, timeFormat, getUrlParam }
